import React, { useEffect, useState } from 'react';

export const InstagramEmbedCustom = (props) => {
  const [postData, setPostData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPostData = async () => {
        try {
            await fetch(`https://graph.instagram.com/v21.0/${props.data.accessTokenID}/media?fields=id,caption,username,media_type,media_url,permalink,timestamp&limit=4&access_token=&access_token=${props.data.accessToken}`)
            .then(res => res.json())
            .then((data) => setPostData(data.data))
        } catch (error) {
            console.error("Error No se pudo obtener los datos de la publicación:", error);
        }
    };

    fetchPostData();
  }, [props.data]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!postData) {
    return <div>Cargando...</div>;
  }

  console.log(postData, "POST Data");

  const handleClickInstagram = () => {
    window.open("https://www.instagram.com/cjperformanceservice/profilecard/", '_blank')
  }

  return (
    <div style={styles.containerInstagram} className="container-servicios">
     <div className='titleInstagram' >
        <img  src="img/ig-logo.png" alt=""/>
      </div>
                  {postData
                      ? postData.map((post, i) => (
                        <div
                        key={`${post.caption || "Instagram Post"}-${i}`}
                        className="col-sm-6 col-md-3 col-lg-3"
                        >

                            {/* {post.media_type === "VIDEO" && ( */}
                    <div style={styles.container}>
                        {/* Header con el nombre de usuario */}
                        <div style={styles.header}>


                                <div style={styles.avatarRing}>
                                <a  onClick={handleClickInstagram}><img  style={styles.avatar}  src="img/logo.jpg" alt=""/></a>
                                </div>
                              <a style={styles.username} onClick={handleClickInstagram}>{post.username}</a>
                        </div>

                          {/* Imagen o Video */}
                          {/*post.media_type === 'IMAGE' || post.media_type === 'CAROUSEL_ALBUM' ? (
                            <img src={post.media_url} alt={post.caption} style={styles.media} />
                          ) :*/}
                          {post.media_type === 'VIDEO' ? (
                            <video controls style={styles.media}>
                              <source src={post.media_url} type="video/mp4" />
                              Tu navegador no soporta videos.
                            </video>
                          ) : null}

                          {/* Descripción */}
                          <div style={styles.caption} >
                            <p>
                                <div className="text-container">
                                <span className="read-more"><a className="read-more-link">Seguir leyendo</a> ...</span>
                                {post.caption}
                              </div>
                            </p>
                          </div>

                         <div style={styles.button}>
                         <button onClick={handleClickInstagram} className="btn btn-custom">Ver perfil</button>
                         </div>

                          {/* Fecha */}
                          <div style={styles.timestamp}>
                            {new Date(post.timestamp).toLocaleDateString('es-ES', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            })}
                          </div>

                          </div>

                    {/* )} */}
                    </div>

                            ))
                            : "Loading..."}
    </div>
  );
};

const styles = {
  containerInstagram: {
    border: '1px solid #ddd',
    borderRadius: '10px',
    overflow: 'hidden',
    fontFamily: 'Arial, sans-serif',
    margin: '20px auto',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  container: {
    maxWidth: '500px',
    border: '1px solid #ddd',
    borderRadius: '10px',
    overflow: 'hidden',
    fontFamily: 'Arial, sans-serif',
    margin: '20px auto',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    borderBottom: '1px solid #eee',
    backgroundColor: '#fafafa',
  },
  avatar: {
    width: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#ffff',
    padding: '1px', // Espacio para el borde
  },
  avatarRing: {
    width: '40px',
   /* height: '40px',*/
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(45deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5)',
    padding: '3px', // Espacio para el borde
  },
  username: {
    fontWeight: 'bold',
    marginLeft: '10px',
    fontSize: '14px',
    color: '#333',
  },
  media: {
    width: '100%',
    display: 'block',
  },
  caption: {
    padding: '10px',
    fontSize: '14px',
    color: '#333',
    borderBottom: '1px solid #ddd',
  },
  button: {
    padding: '10px',
    fontSize: '14px',
    color: '#333',
    borderBottom: '1px solid #ddd',
    textAlign: 'right',

  },
  timestamp: {
    padding: '10px',
    fontSize: '12px',
    color: '#999',
    borderTop: '1px solid #eee',
    textAlign: 'right',
  },
};


/*https://graph.instagram.com/v21.0/17841468077653114/media?fields=id,media_type,media_url,username,caption,timestamp&access_token=IGQWRQdGVBTWhySUZAzMG56WmRnVEwyUXFVTnc3SFZA1N0VPSmZAIZAXd5V01SUnpQallxRkxGWXZAoRGd2bGxfTmJPUXpTUTlFR2tpTWhlbkZA2UFQwMVZAwQmlhUGhGb2V5eDBkLUlkd2lVd0FOVEQ5dEZAqRnZA2OUdTWDAZD*/

/* "https://graph.instagram.com/v21.0/18323012551095932/insights?metric=likes&access_token=IGQWRQdGVBTWhySUZAzMG56WmRnVEwyUXFVTnc3SFZA1N0VPSmZAIZAXd5V01SUnpQallxRkxGWXZAoRGd2bGxfTmJPUXpTUTlFR2tpTWhlbkZA2UFQwMVZAwQmlhUGhGb2V5eDBkLUlkd2lVd0FOVEQ5dEZAqRnZA2OUdTWDAZD" */
